import React, { FC } from 'react';
import { UploadButtonControl, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { Parameters } from '../../../interfaces/Parameters';
import getApiRoot from '../../../utils/getApiRoot';
import { StyledP } from './AttachmentsControl.styles';

export interface AttachmentsControlProps {
  disabled?: boolean;
  currentAttachmentNumber: number;
}

const AttachmentsControl: FC<AttachmentsControlProps> = ({ disabled, currentAttachmentNumber }) => {
  const parameters: Parameters = useScopedSelector('/App.features.securedMessaging.parameters');
  const maxFilesReached = (currentAttachmentNumber || 0) >= parameters.maxAttachmentNumber;
  const i = Math.floor(Math.log(parameters.maxAttachmentSize) / Math.log(1024));
  const authorizedAttachmentSize = parameters.maxAttachmentSize ? parseFloat((parameters.maxAttachmentSize / 1024 ** i).toFixed(0)) : 0;
  const { t } = useTranslation('AttachmentRow');

  return (
    <>
      <StyledP>{t('attachmentLabel', { fileSize: authorizedAttachmentSize, filesAuthorized: parameters.supportedAttachmentExtensions.join(', ') })}</StyledP>
      <UploadButtonControl<number[], { id: number }[]>
        noHint
        maxSize={parameters.maxAttachmentSize}
        accept={parameters.supportedAttachmentTypes}
        multiple
        name="attachments"
        disabled={disabled || maxFilesReached}
        maxFiles={parameters.maxAttachmentNumber}
        addUrl={`${getApiRoot()}/attachments`}
        idPath="data.id"
        formatValueToState={(value) => (value as number[]).map((id) => ({ id }))}
        formatStateToValue={(value) => (value as { id: number }[]).map(({ id }) => (id))}
        multipartFieldName="FileContent"
      >
        {t('attachmentButton')}
      </UploadButtonControl>
    </>
  );
};

export default AttachmentsControl;
